import React from 'react';
import { AuthRoles } from "components/auth";

export const OutputsConfig = {
  auth: AuthRoles.admin,
  routes: [
    {
      path: `${process.env.PUBLIC_URL}/outputs`,
      component: React.lazy(() => import('./Outputs'))
    }
  ]
};